	$(function() {

 const $window = $(window);
 const $document = $(document);
 const $body = $('body');

		const $sliderGrid = $('.js-slier-grid');
		const $progressBarGrid = $sliderGrid.siblings('.grid-progress');

		$sliderGrid.on('init', function(event, slick, currentSlide, nextSlide) {
			let calc = ((slick.currentSlide + 1) / (slick.slideCount - 1)) * 100;
			$progressBarGrid
				.css('background-size', calc + '% 100%')
				.attr('aria-valuenow', calc);
		});

		$sliderGrid.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			let calc = ((nextSlide + 1) / (slick.slideCount)) * 100;

			$progressBarGrid
				.css('background-size', calc + '% 100%')
				.attr('aria-valuenow', calc);
		});

		$sliderGrid.each(function() {
			const $this = $(this);

			if ($window.width() > 767) {
				if ($this.hasClass('slick-initialized')) {
					$this.slick('unslick');
				}
			} else {
				if (!$this.hasClass('slick-initialized')) {
					$this.slick({
						slidesToShow: 1.45,
						arrows: false,
						infinite: false,
					});
				}
			}
		});
	});